/* ---------- KBBQ BROS Custom JS ---------- */

jQuery(document).ready(function($) {

  // home - FAQs 
  $(".home-faq-items").on("click", function(){
    let accInd = $(this).index(".home-faq-items");
    $(".kbbq-home-faq-each").removeClass("active")
    $(".kbbq-home-faq-each").eq(accInd).addClass("active");
    $(".home-faq-slide-toggle").slideUp();
    $(".home-faq-slide-toggle").eq(accInd).slideDown();
  });

  // product desc tab
  $(".prod-desc-tabs-nav li").on("click",function(e){
    let tabInd = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(this).closest(".prod-desc-container").find(".content-each").eq(tabInd)
        .addClass("active").siblings().removeClass("active");
  });

  
});